import { ArrowUpRight } from "lucide-react";

const BASE =
  "group relative inline-flex h-14 items-center justify-center gap-3 px-7 font-sans text-[13px] font-semibold uppercase tracking-[0.16em] transition-[transform,box-shadow,background-color,color,border-color] duration-300 ease-out-expo";

const VARIANTS = {
  primary:
    "bg-pa-orange text-pa-black shadow-hard hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-btn-glow active:translate-x-1 active:translate-y-1 active:shadow-none",
  ghost: "border border-white/20 text-pa-ink hover:border-pa-orange hover:bg-pa-orange/[0.06] hover:shadow-[0_0_36px_-6px_rgba(242,101,49,0.55)]",
  dark:
    "bg-pa-black text-pa-ink shadow-[4px_4px_0_0_#F5F1EB] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_0_#F5F1EB] active:translate-x-1 active:translate-y-1 active:shadow-none",
  "outline-dark": "border border-pa-black/70 text-pa-black hover:bg-pa-black hover:text-pa-ink",
};

export const CtaButton = ({ variant = "primary", children, className = "", icon = true, href, ...props }) => {
  const Tag = href ? "a" : "button";
  return (
    <Tag href={href} type={href ? undefined : "button"} className={`${BASE} ${VARIANTS[variant]} ${className}`} {...props}>
      <span>{children}</span>
      {icon && (
        <ArrowUpRight
          className="h-4 w-4 transition-transform duration-300 ease-out-expo group-hover:rotate-45"
          aria-hidden="true"
        />
      )}
    </Tag>
  );
};
